import { Action } from 'redux';
import { IpDataModel } from '@/models/ip-data.model';
import { WrapperPlatform } from '@/models/enum/wrapper-platform.enum';
import { OntarioLocationCheckStatus } from '@/models/enum/ontario-location-check-status.enum';
import { RegionCheckResponse } from '@/models/region-check.model';

export enum CommonActionType {
  SetLocale = 'SET_LOCALE',
  SetFitToPlay = 'SET_FIT_TO_PLAY',
  SetIpData = 'SET_IP_DATA',
  SetBtag = 'SET_BTAG',
  SetWrapperPlatform = 'SET_WRAPPER_PLATFORM',
  SetOntarioCanPlay = 'SET_ONTARIO_CAN_PLAY',
  SetOntarioLocationCheckStatus = 'SET_ONTARIO_LOCATION_CHECK_STATUS',
  SetDetectedRegion = 'SET_DETECTED_REGION',
}

export type SetLocaleAction = Action<CommonActionType.SetLocale> & { locale: string };
export type SetFitToPlayAction = Action<CommonActionType.SetFitToPlay> & { fitToPlay: boolean };
export type SetIpDataAction = Action<CommonActionType.SetIpData> & { data: IpDataModel };
export type SetBtagAction = Action<CommonActionType.SetBtag> & { btag: string };
export type SetWrapperPlatformAction = Action<CommonActionType.SetWrapperPlatform> & {
  platform: WrapperPlatform;
};
export type SetOntarioCanPlayAction = Action<CommonActionType.SetOntarioCanPlay> & {
  canPlay: boolean;
};
export type SetOntarioLocationCheckedAction =
  Action<CommonActionType.SetOntarioLocationCheckStatus> & {
    status: OntarioLocationCheckStatus;
    error?: string;
  };
export type SetDetectedRegionAction = Action<CommonActionType.SetDetectedRegion> & {
  data: RegionCheckResponse;
};

export type CommonActions =
  | SetLocaleAction
  | SetFitToPlayAction
  | SetIpDataAction
  | SetBtagAction
  | SetWrapperPlatformAction
  | SetOntarioCanPlayAction
  | SetOntarioLocationCheckedAction
  | SetDetectedRegionAction;

export const setLocale = (locale: string): SetLocaleAction => ({
  type: CommonActionType.SetLocale,
  locale,
});

export const setFitToPlay = (fitToPlay: boolean): SetFitToPlayAction => ({
  type: CommonActionType.SetFitToPlay,
  fitToPlay,
});

export const setIpData = (data: IpDataModel): SetIpDataAction => ({
  type: CommonActionType.SetIpData,
  data,
});

export const setBtag = (btag: string): SetBtagAction => ({
  type: CommonActionType.SetBtag,
  btag,
});

export const setWrapperPlatform = (platform: WrapperPlatform): SetWrapperPlatformAction => ({
  type: CommonActionType.SetWrapperPlatform,
  platform,
});

export const setOntarioCanPlay = (canPlay: boolean): SetOntarioCanPlayAction => ({
  type: CommonActionType.SetOntarioCanPlay,
  canPlay,
});

export const setOntarioLocationCheckStatus = (
  status: OntarioLocationCheckStatus,
  error?: string,
): SetOntarioLocationCheckedAction => ({
  type: CommonActionType.SetOntarioLocationCheckStatus,
  status,
  error,
});

export const setDetectedRegion = (data: RegionCheckResponse): SetDetectedRegionAction => ({
  type: CommonActionType.SetDetectedRegion,
  data,
});
